"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CustomAggregateFunctionsProviderService = /** @class */ (function () {
    function CustomAggregateFunctionsProviderService() {
    }
    CustomAggregateFunctionsProviderService.getDefaultTitle = function (functionKey, category, aggregateConfig, groupingFieldValue) {
        if (groupingFieldValue) {
            return groupingFieldValue.getName();
        }
        return "" + functionKey + (functionKey && '_') + (aggregateConfig.sourceField || category) + "_" + (aggregateConfig.aggregateField || 'all');
    };
    return CustomAggregateFunctionsProviderService;
}());
exports.CustomAggregateFunctionsProviderService = CustomAggregateFunctionsProviderService;
//# sourceMappingURL=custom-aggregate-functions-provider.service.js.map